var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 103",
    style: {
      enableBackground: "new 0 0 103 103"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#070101;}\n\t.st1{fill:none;stroke:#070101;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.5,
    cy: 32.7,
    r: 3.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.4,69.4c-7.6-0.2-13.7-1.1-18.6-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.6,61.6c-3.9-2.8-5.7-5.9-6.5-8.1c-0.7-1.9-2.1-3.5-3.7-4.6c-1-0.7-2.2-1.6-3.2-2.7c-1.1-1.2-1.7-3-2.1-4.7 c-0.6-2.5-2.3-4.6-4.7-5.9c-2.1-1.1-4.3-2.8-4.3-5c0-2.5,2.3-3.1,4.3-3.2c1.6-0.1,3.1-0.6,4.4-1.4c1.6-1,4.6-1.9,10-1.2 c9.8,1.2,3.6,7.7,19.7,19.3s42.8,19,50.2-2.7c1.9-5.4,0-13,0-13s6.2,7.1,7.1,13.2c0.8,5.7,2.9,24.7-29.4,27.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.2,77.6c0,0,4.9-3.6,8.1,0.3c3.1,3.9-1.4,6.5-1.4,6.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 20.4,
    y1: 81,
    x2: 24.8,
    y2: 77.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.5,85.5c0,0,4-4.6,7.9-1.5c3.9,3.1,0.1,6.6,0.1,6.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 56,
    y1: 83.8,
    x2: 52.4,
    y2: 88.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.2,53.7c-7.4,6.2-1.1,13.1-2,16.7c-1,3.6-8.4,5.7-8.4,5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.2,58.5c2.7,20.5-5.6,13.8-12.2,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,60c-7,6.7-0.2,13.1-0.9,16.8c-0.7,3.7-8,6.2-8,6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6,64.4c4.1,20.3-4.7,14.1-10.8,21.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 29.8,
    y1: 30.1,
    x2: 36.8,
    y2: 26.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 35.4,
    y1: 36.2,
    x2: 40.7,
    y2: 33.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 40.4,
    y1: 42.5,
    x2: 45.6,
    y2: 39.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 47.5,
    y1: 46.9,
    x2: 50.1,
    y2: 45.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLizard);
export default __webpack_public_path__ + "static/media/lizard.216eaf4fac7b68af8b8beae0ecdaeb50.svg";
export { ForwardRef as ReactComponent };